module.exports = __webpack_public_path__ + "img/pr-1.2a2e9b4c.png";